import { render, staticRenderFns } from "./ProductImageDropdown.vue?vue&type=template&id=de739a06&scoped=true"
import script from "./ProductImageDropdown.vue?vue&type=script&lang=js"
export * from "./ProductImageDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductImageDropdown.vue?vue&type=style&index=0&id=de739a06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de739a06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de739a06')) {
      api.createRecord('de739a06', component.options)
    } else {
      api.reload('de739a06', component.options)
    }
    module.hot.accept("./ProductImageDropdown.vue?vue&type=template&id=de739a06&scoped=true", function () {
      api.rerender('de739a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ProductImageDropdown.vue"
export default component.exports